var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9", attrs: { id: "main" } }, [
              _c("div", { staticClass: "container shortcode travel-ideas" }, [
                _c("h1", { staticClass: "idea-title" }, [
                  _vm._m(0),
                  _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_h4[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_h5_1[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_p_1[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_p_2[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_h5_2[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_h5_21[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_1[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_2[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_3[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_4[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_5[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_6[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_7[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_8[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(_vm.goods_li_9[_vm.getCurrentLocale]),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_10[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_11[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_12[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_13[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_14[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_15[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_16[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("br"),
                _c("h5", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_h5_3[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_p_3[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "check-circle box",
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-left": "15px",
                    },
                  },
                  [
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_17[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_18[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_19[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_20[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("li", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.goods_li_21[_vm.getCurrentLocale]
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_p_4[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.goods_p_5[_vm.getCurrentLocale]),
                  },
                }),
                _c("p"),
                _vm._m(1),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.lba.de/DE/Betrieb/Gefahrgut/Passagierinformation/Passagierinformation_node.html",
            target: "_new",
          },
        },
        [
          _vm._v(
            "https://www.lba.de/DE/Betrieb/Gefahrgut/Passagierinformation/Passagierinformation_node.html"
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }